import { useParams } from 'react-router-dom';
import PageScaffold from '../../../components/PageScaffold';
import { SUBSCRIPTIONS_PAGE_PATH } from '../../subscriptions/SubscriptionsPage';
import { CONTACTS_PAGE_PATH } from '../ContactsPage';
import ChatWindow from '../../../components/@shared/ChatWindow';
import { useNavigate } from 'react-router-dom';
import { OVERVIEW_PAGE_PATH } from '../../OverviewPage';

interface ChatPageProps {
  withSubscriptionIdScope?: boolean;
}

export const CHAT_PAGE_PATH = 'chat';

const ChatPage: React.FC<ChatPageProps> = ({ withSubscriptionIdScope }) => {
  const navigate = useNavigate();

  const { subscriptionId : subscriptionIdParam, contactId } = useParams<{ subscriptionId: string, contactId: string }>();
  const subscriptionId = subscriptionIdParam ? subscriptionIdParam : null;

  if(!contactId) {
    if(subscriptionId) {
      navigate(`${SUBSCRIPTIONS_PAGE_PATH}/${subscriptionId}${CONTACTS_PAGE_PATH}/`);
    } else {
      navigate(OVERVIEW_PAGE_PATH);
    }
    return;
  }

  return (
    <PageScaffold
      title={'Conversation'}
      subtitle={'Consultez et envoyez des messages au contact sélectionné'}
      breadcrumbItems={
        withSubscriptionIdScope
          ? [
              {
                target: SUBSCRIPTIONS_PAGE_PATH,
                title: 'Abonnements',
              },
              {
                target:
                  SUBSCRIPTIONS_PAGE_PATH +
                  '/' +
                  subscriptionId +
                  CONTACTS_PAGE_PATH,
                title: 'Contacts',
              },
              {
                title: 'Conversation',
              },
            ]
          : [
              {
                target: CONTACTS_PAGE_PATH,
                title: 'Contacts',
              },
              {
                title: 'Conversation',
              },
            ]
      }
    >
      <ChatWindow contactId={contactId} />
    </PageScaffold>
  );
};

export default ChatPage;
